import { render, staticRenderFns } from "./UKbranchDetail.vue?vue&type=template&id=b590e858&scoped=true"
import script from "./UKbranchDetail.vue?vue&type=script&lang=js"
export * from "./UKbranchDetail.vue?vue&type=script&lang=js"
import style0 from "./UKbranchDetail.vue?vue&type=style&index=0&id=b590e858&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b590e858",
  null
  
)

export default component.exports